import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexDncRequest = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('get', '/dncs', {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const showDncRequest = (id, { dispatch, params, successCallback, callback }) =>
  ApiService.request('get', `/dncs/${id}`, {
    dispatch,
    params,
    successCallback,
    callback
  });

export const createDncRequest = ({ dispatch, params, successCallback, callback }) =>
  ApiService.request('post', '/dncs', {
    dispatch,
    params,
    successCallback,
    callback
  });

export const updateDncRequest = (id, { dispatch, params, successCallback, callback }) =>
  ApiService.request('put', `/dncs/${id}/`, {
    dispatch,
    params,
    successCallback,
    callback
  });

export const deleteDncRequest = (id, { dispatch, successCallback, callback }) =>
  ApiService.request('delete', `/dncs/${id}`, {
    dispatch,
    successCallback,
    callback
  });

export const indexEmployeeDncRequest = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('get', '/employee_dncs', {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const exportEmployeeDncRequest = ({ dispatch, params, responseType = 'json', successCallback, callback }) => {
  ApiService.request('get', '/employee_dncs.xlsx', {
    dispatch,
    params,
    responseType,
    successCallback,
    callback
  });
};

export const dncCardsRequest = ({ dispatch, successCallback }) =>
  ApiService.request('get', '/dncs/dnc_cards', { dispatch, successCallback });

export const preImportDncRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('get', '/dncs/pre_import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importDncRequest = ({ dispatch, params, formData, failureCallback, successCallback }) => {
  ApiService.request('post', '/dncs/import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });
};

export const importTemplateDncRequest = ({ dispatch, params, failureCallback, successCallback }) => {
  ApiService.request('get', '/dncs/import_template', {
    dispatch,
    params,
    failureCallback,
    responseType: 'text',
    successCallback
  });
};

export const debounceIndexDncRequest = AwesomeDebouncePromise(indexDncRequest, 300);
export const debounceIndexEmployeeDncRequest = AwesomeDebouncePromise(indexEmployeeDncRequest, 300);
